import { OURVEHICLE_GET_LIST,OURVEHICLE_GET_LIST_SUCCESS,OURVEHICLE_GET_LIST_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchVehicleAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}Car/GetAllCarDetails`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const vehicledetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: OURVEHICLE_GET_LIST_SUCCESS, data: vehicledetails });
    } catch (error) {
        yield put({ type: OURVEHICLE_GET_LIST_ERROR, error });
    }
}


export function* watchVehicle() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(OURVEHICLE_GET_LIST, fetchVehicleAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchVehicle),
    ]);
}